import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"
import { downloadCsv } from "./exportCsv"
import { formatCount } from "./UsageTable"

const ActivityMetrics = ({ rows = [] }) => (
    <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6">Intensidade de utilização</Typography>
            <IconButton size="small" title="Baixar CSV: intensidade de utilização" aria-label="Baixar CSV: intensidade de utilização" onClick={() => downloadCsv("kwik-intensidade.csv", [
                { key: "label", label: "Recurso" }, { key: "metric_label", label: "Atividade" },
                { key: "quantity", label: "Quantidade" }, { key: "active_days", label: "Dias com atividade" },
                { key: "per_active_day", label: "Quantidade por dia ativo" },
            ], rows)}><DownloadIcon fontSize="small" /></IconButton>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Histórico preservado no período consultado. Ações são contadas por operação; uma ação em lote conta uma operação.
            Volumes operacionais são consolidados a cada hora. As linhas não devem ser somadas: uma ação pode gerar um registro operacional.
        </Typography>
        <TableContainer>
            <Table size="small" aria-label="Intensidade de utilização">
                <TableHead><TableRow><TableCell>Recurso</TableCell><TableCell>Atividade</TableCell><TableCell align="right">Quantidade</TableCell><TableCell align="right">Dias com atividade</TableCell><TableCell align="right">Quantidade por dia ativo</TableCell></TableRow></TableHead>
                <TableBody>{rows.map(row => <TableRow key={`${row.module}-${row.channel}-${row.metric}`}>
                    <TableCell>{row.label}</TableCell><TableCell>{row.metric_label}</TableCell><TableCell align="right">{formatCount(row.quantity)}</TableCell><TableCell align="right">{formatCount(row.active_days)}</TableCell><TableCell align="right">{formatCount(row.per_active_day)}</TableCell>
                </TableRow>)}</TableBody>
            </Table>
        </TableContainer>
        {!rows.length && <Typography variant="body2">Nenhuma atividade preservada para este período.</Typography>}
    </Box>
)

export default ActivityMetrics
